<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入用户ID/手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
      </div>
      <el-button style="margin-right:16px;" @click="handleVerify" type="warning">兑换核销</el-button>
    </div>
    <div class="search-container">
      <div style="margin-right:30px;" class="certificationRecord">
        <el-radio-group v-model="radio" @change="changeRadio">
          <el-radio :label="4">全部</el-radio>
          <el-radio :label="0">未核销</el-radio>
          <el-radio :label="1">已核销</el-radio>
        </el-radio-group>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" width="250px" label="会员">
              <template slot-scope="scope">
                <div class="pay-member-photo">
                  <img :src="scope.row.member_wxheadurl" />
                </div>
                <div v-if="scope.row.member_name!==''" class="pay-member-name">{{ scope.row.member_name }}<br />ID：{{ scope.row.member_mid }}</div>
                <div v-else class="pay-member-name">{{ scope.row.member_wxname }}<br />ID：{{ scope.row.member_mid }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="商品封面">
              <template slot-scope="scope">
                  <img width="60" :src="scope.row.goods_coverimg" />
              </template>
            </el-table-column>
            <el-table-column align="center" label="商品名称">
              <template slot-scope="scope">
               <span>{{scope.row.goods_title}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="160px" label="兑换时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createtime }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="核销码">
              <template slot-scope="scope">
                <span>{{ scope.row.cdkey }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="使用积分">
              <template slot-scope="scope">
                <span>{{ scope.row.costpoints }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="有效期" width="160px">
              <template slot-scope="scope">
               <span>{{ scope.row.starttime === scope.row.endtime ? '永久有效' : `${scope.row.starttime} - ${scope.row.endtime}`}}</span>
              </template>
            </el-table-column>
            <el-table-column width="100px" align="center" label="状态">
              <template slot-scope="scope">
                <span>{{changeStatus(scope.row.status )}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="备注">
              <template slot-scope="scope">
                <span>{{ scope.row.remark}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100px" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleRemark(scope.row)">备注</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" :page-size="pageSize" layout="prev, pager, next" :current-page="page" :total="total">
      </el-pagination>
    </el-container>
    <verify-modal ref="modalVerify" @ok="loadData"></verify-modal>
    <el-dialog title="备注" :visible.sync="dialogVisibleRemark" width="30%" @close="handleClose">
      <el-input type="textarea" v-model="desc"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleAffirmRemark">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import { exchangeList, setExchangeRemark } from '@/views/webpc/CreditMall/ExchangeListApp/apis'
import VerifyModal from './modules/verifyModal'
export default {
  components: { VerifyModal },
  data () {
    return {
      pageSize: 20,
      page: 1,
      total: 0,
      dialogVisible: false,
      radio: 4,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      valuedate: '',
      valueid: '',
      tableData: [],
      dialogVisibleRemark: false,
      desc: '',
      params: {}
    }
  },
  methods: {
    // 核销积分
    handleVerify () {
      this.$refs.modalVerify.show()
    },
    // 状态转换
    changeStatus (status) {
      status = parseInt(status)
      switch (status) {
        case 0:
          return '未核销'
        case 1:
          return '已核销'
        default:
          return '其他'
      }
    },
    // 验证记录
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      if (this.radio < 4) {
        data.append('status', this.radio)
      }
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      exchangeList(data)
        .then(result => {
          if (result) {
            this.isLoading = false
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        }).catch(error => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    // 分页
    changeRadio () {
      this.page = 1
      this.loadData()
    },
    // 备注
    handleRemark (params) {
      this.params = params
      this.desc = params.remark
      this.dialogVisibleRemark = true
    },
    handleClose () {
      this.params = {}
      this.desc = ''
      this.dialogVisibleRemark = false
    },
    handleAffirmRemark () {
      let data = new FormData()
      data.append('id', this.params.id)
      data.append('remark', this.desc)
      setExchangeRemark(data)
        .then(result => {
          if (result) {
            this.dialogVisibleRemark = false
            this.loadData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        }).catch(error => {
          if (error) {
          }
        })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CreditMall/ExchangeListApp/ExchangeList.vue